/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';
import { ContactCard } from 'C4';

const ContactGroup = ({ office, salesRegion, adressLines, contacts }) => {
  return (
    <Fragment>
      <div className="contactsHeader">
        <h1>Sales - {salesRegion}</h1>
        <p>
          {adressLines.map((line) => (
            <Fragment key={Math.ceil(Math.random() * 100000)}>
              {line}
              <br />
            </Fragment>
          ))}
        </p>
        {/* {!contacts && <p>Contacts array not present</p>}
        {contacts && <p>Contacts Array present. </p>} */}
      </div>
      {contacts.map((contact) => (
        <ContactCard
          name={contact.name}
          description={contact.description}
          telephone={contact.telephone}
          mail={contact.mail}
          imageUrl={contact.imageUrl}
          town={office}
        />
      ))}
    </Fragment>
  );
};

export default ContactGroup;
